import { sfOr } from 'spring-filter-query-builder';
import { VicGridReadDTO } from '../../api/dto';
import { escapeSfqbString } from '../sfqb';
import { sfLike } from './sfqb';

export const makeVicFilter = (searchParam: string): string => {
    const likeQuery = `${escapeSfqbString(searchParam, true)}*`;
    return sfOr(
        (['title', 'id'] satisfies (keyof VicGridReadDTO)[]).map((field) => sfLike(field, likeQuery, true))
    ).toString();
};
